import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SimpleRefrigeration } from '../../models/simple-refrigeration';
import { SimpleRefrigerationBuilder } from '../../models/builders/simple-refrigeration.builder';

const refrigerationBody = (simpleRefrigeration: SimpleRefrigeration) => ({
  name: simpleRefrigeration.name
});

@Injectable()
export class SimpleRefrigerationApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }simpleRefrigerations`;
  }

  createSimpleRefrigeration(refrigeration) {
    // tslint:disable-next-line: max-line-length
    return this.httpClient.post(this.apiUrl, refrigerationBody(refrigeration)).pipe(map(SimpleRefrigerationBuilder.fromJson));
  }

  deleteSimpleRefrigeration(refrigeration: SimpleRefrigeration) {
    return this.httpClient.delete(`${ this.apiUrl }/${ refrigeration.hash }`);
  }

  getSimpleRefrigerations() {
    return this.httpClient.get(this.apiUrl).pipe(map(SimpleRefrigerationBuilder.fromList));
  }

  getSimpleRefrigeration(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(SimpleRefrigerationBuilder.fromJson));
  }

  updateSimpleRefrigeration(refrigeration: SimpleRefrigeration) {
    return this.httpClient.put(`${ this.apiUrl }/${ refrigeration.hash }`, refrigerationBody(refrigeration));
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/simple-refrigeration-api.service.ts